var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.996,
    height: 12.013,
    viewBox: "0 0 11.996 12.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83575",
    "data-name": "Group 83575",
    transform: "translate(-156.251 -124.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.944,11.471c-1.379.2-4.182,2.359-4.476,4.476a6,6,0,0,0,1.2,5.135.6.6,0,0,0,.936-.756,4.8,4.8,0,1,1,1.6,1.284.616.616,0,0,0-.558,1.1,6.005,6.005,0,1,0,1.3-11.237Z",
    transform: "translate(144.934 112.934)",
    fill: "#f4aa74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M2.4,5.4a.6.6,0,0,1-.426-.174l-1.8-1.8A.6.6,0,0,1,0,3V.6A.6.6,0,1,1,1.2.6V2.754l1.626,1.62A.6.6,0,0,1,2.4,5.4Z",
    transform: "translate(161.003 127.243)",
    fill: "#f4aa74"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.b5ec04b20f766d9a9586771764061ae0.svg";
export { ForwardRef as ReactComponent };